$(function () {

  var $body = $('body');

  const enquiryContent = {
    'Course Guide': {
      link: {
        url: '/about-us/publications',
        text: 'The South West TAFE Course Guide is available to download here.'
      },
      text: 'If you would like to get in touch regarding the course guide, please continue and fill out the form below.'
    },
    'Apprenticeships and Traineeships': {
      link: {
        url: '/apprenticeships-traineeships',
        text: 'Information about Apprenticeships and Traineeships can be found here.'
      },
      text: 'If you would like to get in touch regarding Apprenticeships and Traineeships, please continue and fill out the form below.'
    },
    'Scholarships': {
      link: {
        url: '/study/scholarships',
        text: 'Information about our scholarships can be found here.'
      },
      text: 'If you would like to get in touch regarding our scholarships, please continue and fill out the form below.'
    },
    'Awards (Certificates & Statement of Attainment)': {
      link: {
        url: '/students/graduation-awards',
        text: 'Information about our graduations and awards can be found here.'
      },
      text: 'If you would like to get in touch regarding graduations and awards, please continue and fill out the form below.'
    },
    'Skills & Jobs Centre': {
      link: {
        url: '/pathfinders',
        text: 'Information about Pathfinders Skills & Jobs Centre can be found here.'
      },
      text: 'If you would like to get in touch regarding the Pathfinders Skills & Jobs Centre, please continue and fill out the form below.'
    },
    'Short Courses': {
      link: {
        url: '/courses/short-courses',
        text: 'Information about short courses can be found here.'
      },
      text: 'If you would like to get in touch regarding short courses, please continue and fill out the form below.'
    },
    'Secondary School Student (VETDSS)': {
      link: {
        url: 'https://vetdss.swtafe.edu.au/',
        text: 'Information about VETDSS can be found on our VETDSS Portal.'
      },
      text: 'If you would like to get in touch regarding VETDSS, please continue and fill out the form below.'
    },
    'Feedback and Complaints': {
      link: {
        url: '/about-us/feedback',
        text: 'Information about feedback and complaints can be found here.'
      },
      text: 'If you would like to get in touch regarding feedback and complaints, please continue and fill out the form below.'
    }
  }

  // only works on Ask a question form page
  if (!$body.hasClass('page-type--askaquestionform')) return;

  var $form = $('#ask-a-question-form');

  var $whatAreYouInterested = $('#WhatAreYouInterested-Another');
  var $whatAreYouInterestedNotSure = $('#WhatAreYouInterested-NotSure');
  var $courseAreas = $('#UserCourseAreas');

  var $contactEmail = $('#contact-email');
  var $contactPhone = $('#contact-phone');

  var $contactEmailAddress = $('#Email');
  var $subscribeToMailingList = $('#SubscribeToMailingList');

  var $contactPhoneNumber = $('#PhoneNumber');
  var $contactTime = $('#ContactTime');
  var $whatLevelAreYouInterested = $('#what-level-are-you-interested');
  var $preSelectedInterestedStudy = $('#WhatAreYouInterested-Preselected');

  var $whatWillBeStudyLocation = $('#what-will-be-your-study-location');

  var $loadingIndicator = $('.swtafe-form__loading-indicator');

  var $enquiryType = $('#EnquiryType');

  var $orgunitSelects = $('#OrgUnit');
  var $orgunitNotSure = $('#OrgUnitNotSure');

  function notSureOrgunit() {
    const enquiry = $enquiryType.find(":selected").text();
    if (enquiry === '' || enquiry === 'Course Enquiry') {
      if ($preSelectedInterestedStudy.prop('checked')) {
        $orgunitSelects.prop('disabled', true);
        $orgunitNotSure.prop('disabled', true);
      } else {

        if ($whatAreYouInterestedNotSure.prop('checked')) {
          // const orgunitNotSureValue = $orgunitSelects.find('option').filter(function () {
          //   return $(this).html() === "Not sure";
          // }).val();
          // $orgunitSelects.val(orgunitNotSureValue);
          $orgunitNotSure.val(true);
          $orgunitNotSure.prop('disabled', false);
          $orgunitSelects.prop('disabled', true);
        } else {
          $orgunitNotSure.val(false);
          $orgunitNotSure.prop('disabled', true);
          $orgunitSelects.prop('disabled', false);
        }
      }
    }
  }
  $whatAreYouInterested.change(function () {
    notSureOrgunit();
  })
  $whatAreYouInterestedNotSure.change(function () {
    notSureOrgunit();
  })
  $preSelectedInterestedStudy.change(function () {
    notSureOrgunit();
  })

  notSureOrgunit();

  // The study level dropdown shows only if the enquirer selects a study area,
  // or ‘I’m not sure’ (anything other than the preselected course code)
  function hideInterestedLevel() {

    if ($preSelectedInterestedStudy.length) {
      var hide = $preSelectedInterestedStudy.is(':checked');
      if (hide) {
        $whatLevelAreYouInterested.hide();
        $whatLevelAreYouInterested.find('select').prop('disabled', true);
      }
      $whatAreYouInterested.change(function () {
        $whatLevelAreYouInterested.show();
        $whatLevelAreYouInterested.find('select').prop('disabled', false);
      })
      $whatAreYouInterestedNotSure.change(function () {
        $whatLevelAreYouInterested.show();
        $whatLevelAreYouInterested.find('select').prop('disabled', false);

      })
      $preSelectedInterestedStudy.change(function () {
        $whatLevelAreYouInterested.hide();
        $whatLevelAreYouInterested.find('select').prop('disabled', true);
      })
    }
  }
  hideInterestedLevel();

  // only show fields when selecting Course Enquiry
  function showCourseEnquiry () {
    const enquiry = $enquiryType.find(":selected").text()
    const $startYear = $('#what-year-you-start');
    const $whatAreYouInterestedArea = $('#what-are-you-interested');

    const $enquiryContent = $('.swtafe-form__enquiry-content');
    const $enquiryLink = $('.swtafe-form__enquiry-content .swtafe-form__enquiry-link');
    const $enquiryText = $('.swtafe-form__enquiry-content .swtafe-form__enquiry-text');

    if (enquiry) {
      if (enquiry === 'Course Enquiry') {
        $startYear.show();
        $whatAreYouInterestedArea.show();
        $whatLevelAreYouInterested.show();
        $whatWillBeStudyLocation.show();
        $whatAreYouInterestedArea.find('input').prop('disabled', false);
        $whatWillBeStudyLocation.find('input').prop('disabled', false);
        $whatLevelAreYouInterested.find('select').prop('disabled', false);
        $whatAreYouInterested.parent().find('select').prop('disabled', false);
        $startYear.find('select').prop('disabled', false);
      } else {
        $startYear.hide();
        $whatAreYouInterestedArea.hide();
        $whatLevelAreYouInterested.hide();
        $whatWillBeStudyLocation.hide();
        $whatAreYouInterestedArea.find('input').prop('disabled', true);
        $whatWillBeStudyLocation.find('input').prop('disabled', true);
        $whatLevelAreYouInterested.find('select').prop('disabled', true);
        $whatAreYouInterested.parent().find('select').prop('disabled', true);
        $startYear.find('select').prop('disabled', true);
      }

      if (Object.prototype.hasOwnProperty.call(enquiryContent, enquiry)) {
        $enquiryContent.show();
        $enquiryText.text(enquiryContent[enquiry].text);
        $enquiryLink.attr('href', enquiryContent[enquiry].link.url);
        $enquiryLink.text(enquiryContent[enquiry].link.text);
      } else {
        $enquiryContent.hide();
      }
    }
  }
  showCourseEnquiry();

  $enquiryType.change(function () {
    showCourseEnquiry();
  })

  $.validator.addMethod("courseAreaNeeded", function (value, element, arg) {
    if ($whatAreYouInterested.prop('checked')) {
      return value !== '-1';
    }

    return true;
  }, "Course area must be selected.");

  $.validator.addMethod("phoneValidation", function (value, element, arg) {
    var isValidPhone = true;
    if ($('#contact-phone').is(':checked')) {
      isValidPhone = window.phoneNumberParser ? window.phoneNumberParser() : null;
      if (isValidPhone !== true) {
        return false;
      }
    }

    return true;
  }, "Please enter a valid phone number.");

  $.validator.addMethod("emailValidation", function (value, element, arg) {

    if ($('#contact-email').is(':checked')) {

      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value);
    }

    return true;
  }, "Please enter a valid email address.");

  var validator = $form.validate({
    // debug:true, // when debug on, form would not be sent.
    rules: {
      FirstName: {
        required: true
      },
      LastName: {
        required: true
      },
      DescribeYourself: {
        required: true
      },
      UserCourseAreas: {
        courseAreaNeeded: true
      },
      Enquiry: {
        required: true
      },
      Email: {
        required: true, // always required
        // required: '#contact-email:checked',
        // email: true,
        emailValidation: true,
      },
      PhoneNumber: {
        required: '#contact-phone:checked',
        // digits: true,
        phoneValidation: true
      },
    },
    messages: {
      UserCourseAreas: {
        courseAreaNeeded: 'Required'
      },
    }
  });

  $courseAreas.change(function() {
    $whatAreYouInterested.prop('checked', true);
  });

  function updateContacts(e, init) {
    var selected = 0;
    if ($contactEmail.prop('checked')) selected++;
    if ($contactPhone.prop('checked')) selected++;

    // toggle options
    // $contactEmail.prop('disabled', $contactEmail.prop('checked') && selected < 2 ? 'disabled' : '');
    // $contactPhone.prop('disabled', $contactPhone.prop('checked') && selected < 2 ? 'disabled' : '');

    // toggle email fields
    // $contactEmailAddress.prop('disabled', !$contactEmail.prop('checked'));
    $subscribeToMailingList.prop('disabled', !$contactEmail.prop('checked'));

    // toggle phone fields
    //$contactPhoneNumber.prop('disabled', !$contactPhone.prop('checked'));
    $contactTime.prop('disabled', !$contactPhone.prop('checked'));

    // toggle active classes
    // $contactEmail.parents('.swtafe-form__contact').toggleClass('active', $contactEmail.prop('checked'));
    // $contactPhone.parents('.swtafe-form__contact').toggleClass('active', $contactPhone.prop('checked'));

    // toggle disabled classes
    // $contactEmail.parents('.swtafe-form__contact').find('.swtf-sub-form').toggleClass('disabled', !$contactEmail.prop('checked'));
    // $contactPhone.parents('.swtafe-form__contact').find('.swtf-sub-form').toggleClass('disabled', !$contactPhone.prop('checked'));

    if(!init) {
      // clear validations
      if(!$contactEmail.prop('checked'))
        validator.element('#Email');

      if(!$contactPhone.prop('checked'))
        validator.element('#PhoneNumber');
    }
  }

  $('input[name=ContactMethods]').change(updateContacts);

  updateContacts(null, true);

  function _updateErrorBlocks() {

    $courseAreas.parents('.swtf-control__radio')
        .toggleClass('has-error', $courseAreas.hasClass('error'));

    $contactEmailAddress.parents('.swtafe-form__contact')
        .toggleClass('has-error', $contactEmailAddress.hasClass('error'));

    $contactPhoneNumber.parents('.swtafe-form__contact')
        .toggleClass('has-error', $contactPhoneNumber.hasClass('error'));
  }

  var _debouncedUpdateErrorBlocks;

  function updateErrorBlocks() {
    if (_debouncedUpdateErrorBlocks) {
      clearTimeout(_debouncedUpdateErrorBlocks);
    }

    _debouncedUpdateErrorBlocks = setTimeout(_updateErrorBlocks, 250);
  }

  $form.change(updateErrorBlocks);

  var GA_LEAVE_WITHOUT_SUBMIT = true;

  $form.on('submit', function (e) {
    var form = $(this);
    $loadingIndicator.show();

    if (!form.valid()) {
      alert('We weren\'t able to send your enquiry, please check all fields and try again.');
      updateErrorBlocks();
      e.preventDefault();
      $loadingIndicator.hide();
      return;
    }
    notSureOrgunit();

    if ($preSelectedInterestedStudy.prop('checked')) {
      $(form[0].OrgUnit).val(null);
      $('#Course').prop('disabled', true);
    }

    if($('input[name=Campus]:checked').length < 1) {
      $('#campus-not-sure').prop('checked', true);
    }

    console.log('ask a question form sent.');

    GA_LEAVE_WITHOUT_SUBMIT = false;

    gtag && gtag('event', 'Successfully submit', {
      event_category: 'Ask A Question Form',
      event_label: 'Submit',
      transport_type: 'beacon'
    });
  });

  $(window).on('unload', function(){
    if(GA_LEAVE_WITHOUT_SUBMIT) {
      gtag && gtag('event', 'Leave page without submitting', {
        event_category: 'Ask A Question Form',
        transport_type: 'beacon'
      });
    }
  })

  const control = document.querySelector('.study-area-other__control select');
  const otherField = document.querySelector('.study-area-other__field');
  if (control && otherField) {
    window.otherKey = '';
    const options = control.childNodes;
    for (var i = 0; i < options.length; i += 1) {
        const opt = options[i];
        const label = opt.innerText;
        if (opt && label && label.toLowerCase().includes('other')) {
            window.otherKey = opt.value;
        }
    }
    if (window.otherKey) {
        control.addEventListener('change', function() {
            if (control.value === window.otherKey) {
                otherField.classList.add('visible');
            } else {
                otherField.classList.remove('visible');
            }
        });
    }
  }

  const prefNameField = document.querySelector('.pref-name-control');
  const prefNameNote = document.querySelector('.pref-name-note');
  if (prefNameField && prefNameNote) {
    prefNameField.addEventListener('input', function(e) {
        if (e.target.value) {
            prefNameNote.classList.add('show');
        } else {
            prefNameNote.classList.remove('show');
        }
    });
  }
});
